import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy} from '@angular/core';

@Component({ standalone: false,
  selector: 'irb-dropdown',
  templateUrl: './dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class DropdownComponent implements OnInit {
  @Input() options: Array<any>;
  @Output() selection = new EventEmitter<any>();

  optionsArray: Array<any>;
  _value: any;

  constructor() {}

  ngOnInit() {
  }

  @Input()
  get value() {
    return this._value;
  }

  set value(newVal) {
    this._value = newVal;
  }
  
  onChange(event: any) {
    this._value = event.value;
    this.selection.emit(this._value);
  }
}
